const React = require("react")
const Close = require("shared/assets/svg/close-icon.svg")
const CloseButtonGreen = require("shared/assets/svg/close-button-green.svg")

module.exports = {
  close: <Close />,
  closeButtonSecondary: <CloseButtonGreen />
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/modernModal/index.js